// src/pages/Login.tsx
import React, { useState, useEffect } from 'react'; // ✅ add useEffect
import { Link } from 'react-router-dom';
import axios from '../api/axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './Login.module.css'; // <--- Import your CSS module

const Login: React.FC = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showNewSiteBanner, setShowNewSiteBanner] = useState(() => {
    const viewCount = parseInt(localStorage.getItem('newSiteBannerViewCount') || '0', 10);
    const dismissed = localStorage.getItem('newSiteBannerDismissed') === 'true';
    return viewCount < 10 && !dismissed;
  });
  
  useEffect(() => {
    if (showNewSiteBanner) {
      const currentCount = parseInt(localStorage.getItem('newSiteBannerViewCount') || '0', 10);
      localStorage.setItem('newSiteBannerViewCount', (currentCount + 1).toString());
    }
  }, [showNewSiteBanner]);
  
  const dismissBanner = () => {
    localStorage.setItem('newSiteBannerDismissed', 'true');
    setShowNewSiteBanner(false);
  };
  
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post('/auth/login', {
        Username: username,
        Password: password,
      });
      
      login(response.data.token);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <h2 className={styles.loginTitle}>Login</h2>
      {showNewSiteBanner && (
        <div className={styles.noticeMessage}>
          <p>
            ⚠️ This is a brand new site. Accounts from the old website were not carried over.
            Please <Link to="/register">register again</Link> to access the new system.
          </p>
          <button onClick={dismissBanner} className={styles.dismissButton}>×</button>
        </div>
      )}
      <form onSubmit={handleLogin} className={styles.loginForm}>
        <div className={styles.formGroup}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className={styles.input}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={styles.input}
            required
          />
        </div>
        <div className={styles.forgotPasswordLink}>
          <Link to="/forgot-password">Forgot Password?</Link>
        </div>
        <button type="submit" disabled={loading} className="button">
          {loading ? 'Logging in...' : 'Login'}
        </button>
        {error && <p className={styles.errorMessage}>{error}</p>}
      </form>

      {/* Register link below the form */}
      <p className={styles.registerPrompt}>
        Don’t have an account? <Link to="/register">Register</Link>
      </p>
    </div>
  );
};

export default Login;
